export default __webpack_public_path__ + "static/media/helm.ce85c4ed.svg";